// Arrows and position dots for the swipeable image strip on collection cards (snippets/card-product.liquid, gallery: true).
// Slides after the first stay hidden and unloaded (data-src) until this script marks the gallery ready and the card is first touched,
// hovered, focused or scrolled; without this script the card simply shows its first image.
if (!customElements.get('card-gallery')) {
  const CHEVRON = (points) =>
    `<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><polyline points="${points}"/></svg>`;

  class CardGallery extends HTMLElement {
    connectedCallback() {
      this.strip = this.querySelector('.card-gallery__strip');
      if (!this.strip || this.dots) return;
      const count = this.strip.children.length;
      if (count < 2) return;

      this.dots = document.createElement('span');
      this.dots.className = 'card-gallery__dots';
      this.dots.setAttribute('aria-hidden', 'true');
      this.dots.innerHTML = '<i></i>'.repeat(count);

      this.prev = this.createArrow('prev', 'Previous image', CHEVRON('15 6 9 12 15 18'));
      this.next = this.createArrow('next', 'Next image', CHEVRON('9 6 15 12 9 18'));
      this.append(this.prev, this.next, this.dots);

      this.index = -1;
      this.ticking = false;
      this.strip.addEventListener('scroll', () => this.requestUpdate(), { passive: true });
      this.update();

      this.setAttribute('data-ready', '');
      this.load = this.load.bind(this);
      ['pointerenter', 'touchstart', 'focusin'].forEach((type) => this.addEventListener(type, this.load, { once: true, passive: true }));
      this.strip.addEventListener('scroll', this.load, { once: true, passive: true });
    }

    load() {
      if (this.loaded) return;
      this.loaded = true;
      this.strip.querySelectorAll('img[data-src]').forEach((img) => {
        img.srcset = img.dataset.srcset;
        img.src = img.dataset.src;
        img.removeAttribute('data-src');
        img.removeAttribute('data-srcset');
      });
    }

    createArrow(direction, label, icon) {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = `card-gallery__arrow card-gallery__arrow--${direction}`;
      button.setAttribute('aria-label', label);
      button.innerHTML = icon;
      button.addEventListener('click', () => this.go(direction === 'next' ? 1 : -1));
      return button;
    }

    go(step) {
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.strip.scrollBy({ left: step * this.strip.clientWidth, behavior: reduceMotion ? 'auto' : 'smooth' });
    }

    requestUpdate() {
      if (this.ticking) return;
      this.ticking = true;
      requestAnimationFrame(() => {
        this.ticking = false;
        this.update();
      });
    }

    update() {
      const { strip } = this;
      const index = Math.round(Math.abs(strip.scrollLeft) / (strip.clientWidth || 1));
      if (index === this.index) return;
      this.index = index;
      Array.from(this.dots.children).forEach((dot, i) => dot.classList.toggle('is-active', i === index));
      this.prev.disabled = index === 0;
      this.next.disabled = index === strip.children.length - 1;
    }
  }

  customElements.define('card-gallery', CardGallery);
}
